<template>
    <div class="container-fluid min-vh-100 bg-location">
    <div class="location container pt-5 my-5">

        <h1 class="display-1">{{ location.name }}</h1>

        <div class="p-5 text-center rounded-3">
        
            <div v-if="location" class="card">

            <h1 class="card-header">{{location.name}}</h1>
            <div class="card-body">
                <h5 class="card-title">Type: {{location.type}}</h5>
                <p class="card-text">Dimension: {{ location.dimension }}</p>
            </div>
            </div>
            <div v-else>No Location</div>
        
        </div>


        <button @click="mall(location.residents)" class="btn btn-secondary mb-5">Show Residents</button>
                
        <div class="row row-cols-1 row-cols-md-5 g-4 justify-content-evenly">
        
            <div v-bind:key="char" v-for="(char) in chars" >
                <div v-if="char">
                    <div class="card">
                        <div class="card-header">
                            {{char.status}}
                        </div>
                        <div class="card-body">
                            <router-link :to="{name:'character', params:{id:char.id}}" class="routerlink">
                                <a>{{char.name}}</a>
                            </router-link>
                        </div>
                        <div class="card-footer">
                            {{char.species}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        
        
        
    </div>
    </div>
</template>

<script>

import getLocation from '@/composables/getLocation.js';
import getCharacter from '@/composables/characters/getCharacter.js';
import getCharacters from '@/composables/characters/getCharacters.js';

export default {
    props: ['id'],
    setup( props ) {
        const { location, error, load } = getLocation( props.id )
        load()
        return { location, error }
    },
    data() {
        return{
            chars:'',
            sing: ''
        }
    },
    methods: {
        fetchCharacter( char ) {
            console.log( char.split('/character/')[1] );
            const { character, errorc, loadc } = getCharacter(char.split('/character/')[1])
            loadc()
            this.sing = character
            // return { character, errorc }
         },
        mall (res) {
            const{ characters, loadch } = getCharacters(res)
            loadch()
            console.log(characters)
            this.chars = characters
            return { characters }
        }
    }
}
</script>

<style scoped>
.bg-location {
    background-color:antiquewhite;
  background-image: var(--bs-gradient); 
}
</style>